import Text from 'components/shared/Text'
import { DiscountBadgeBox } from './styles'
import InfoTooltip from 'components/shared/InfoTooltip'
import { HighlightDto } from 'store/api-slice/hooks'

interface DiscountBadgeProps {
    element: HighlightDto
}

export const DiscountBadge = ({ element }: DiscountBadgeProps) => (
    <>
        <DiscountBadgeBox direction="row" align="center">
            <InfoTooltip
                icon="ticket-discount"
                message={
                    <span
                        dangerouslySetInnerHTML={{
                            __html: element.message ?? '',
                        }}
                    />
                }
                mobilePlacement="top"
                size={34}
                additionalElement={
                    <Text variant="body" color="primary_500" ml={8}>
                        {element.name}
                    </Text>
                }
            />
        </DiscountBadgeBox>
    </>
)
